import { render } from "./PasswordResetConfirmation.vue?vue&type=template&id=a4a9b79e&scoped=true"
const script = {}

import "./PasswordResetConfirmation.vue?vue&type=style&index=0&id=a4a9b79e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a9b79e"]])

export default __exports__